import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { hydrateFromDb, startAutoPersist } from './lib/storage/autoPersist';
import './styles/globals.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

// Start the IndexedDB sync before the first render so /editor/:id can resolve
// a freshly-stored fiche without a flash of "not found".
startAutoPersist();
hydrateFromDb().catch((err) => {
  console.warn('Hydrate from DB failed:', err);
});

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service worker registration is delegated to <UpdatePrompt /> so the
// onNeedRefresh / onOfflineReady callbacks can drive in-app toasts.
